const move = (domNode, left, top) => {

  domNode.style.left = left + 'px'
  domNode.style.top = top + 'px'

}

module.exports = move



// WEBPACK FOOTER //
// ../build/helpers/move.js